export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/DK-958c14e0fdd909b0dbdcf819f077b306.png";